export const TRAFFIC_FINE_CHARGE_SURCHARGE = 25;

export type TrafficFineChargeMultiplier = 1 | 2 | 3;

export interface TrafficFineChargeOption {
  multiplier: TrafficFineChargeMultiplier;
  label: string;
  subtitle: string;
}

export const TRAFFIC_FINE_CHARGE_OPTIONS: TrafficFineChargeOption[] = [
  { multiplier: 1, label: 'Original', subtitle: '1× + R$ 25,00' },
  { multiplier: 2, label: 'Duplicar', subtitle: '2× + R$ 25,00' },
  { multiplier: 3, label: 'Triplicar', subtitle: '3× + R$ 25,00' }
];

export function calculateTrafficFineChargeAmount(
  originalAmount: number,
  multiplier: TrafficFineChargeMultiplier
): number {
  const base = Number(originalAmount);
  if (!Number.isFinite(base) || base <= 0) {
    return 0;
  }
  return Math.round((base * multiplier + TRAFFIC_FINE_CHARGE_SURCHARGE) * 100) / 100;
}
